import { ProtectorApi } from '@core/api';
import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '../useOrganization';
import { useReadUserNotification } from './useReadUserNotification';
import { UserNotificationDTO } from './userNotifications.models';

function useUserNotifications() {
  const { mutate } = useReadUserNotification();
  const { organization } = useOrganization();
  const query = useQuery({
    queryKey: ['user-notifications', { workspace_id: organization?.workspace_id }],
    queryFn: async () => {
      const { data } = await ProtectorApi.get<UserNotificationDTO[]>(
        '/user-notifications/notification/explorer'
      );

      return data.reduce<{ [key: string]: UserNotificationDTO }>((acc, cur) => {
        const { workspace_id } = cur.user_notification.content;

        if (!workspace_id || workspace_id === organization?.workspace_id) {
          acc[cur.id] = cur;
        }
        return acc;
      }, {});
    },
  });

  // eslint-disable-next-line @tanstack/query/no-rest-destructuring -- long-standing public return shape; narrowing it to specific fields would change every consumer
  return { ...query, readNotifications: mutate };
}

export { useUserNotifications };
